import { defineComponent as _defineComponent } from 'vue'
import {
  PropType,
  computed,
  onMounted,
  onUnmounted,
  ref,
} from 'vue'

import {
  useI18n
} from '@/composables/useI18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'DeleteItemsDialog',
  props: {
  selectedNumbers: {
    type: Array as PropType<number[]>,
    default() {
      return []
    }
  },
  headline: {
    required: false,
    type: String as PropType<string>,
    default: '',
  },
  text: {
    required: false,
    type: String as PropType<string>,
    default: '',
  }
},
  emits: [
  'onDialogCancel',
  'onDialogConfirm'
],
  setup(__props, { emit: emits }) {

const props = __props;

const {
  t,
  tc
} = useI18n();





const isDialogVisible = ref<boolean>(false);

const selectedCardsToDelete = computed(
  () => props.selectedNumbers?.join(', ')
)

const getDefaultText = computed(
  () => tc('delete_items.text', props.selectedNumbers.length, {count: props.selectedNumbers.length})
);

const getDefaultHeadline = computed(
  () => t('delete_items.headline')
);

const onHandleDialogCancel = () => {
  isDialogVisible.value = false;
  emits('onDialogCancel');
};

const onHandleDialogDeleteConfirm = () => {
  isDialogVisible.value = false;
  emits('onDialogConfirm');
};

onMounted(() => {
  isDialogVisible.value = true;
});

onUnmounted(() => {
  isDialogVisible.value = false;
})

return { __sfc: true,t, tc, props, emits, isDialogVisible, selectedCardsToDelete, getDefaultText, getDefaultHeadline, onHandleDialogCancel, onHandleDialogDeleteConfirm }
}

})